export enum LocalStorageKeyEnum {
  ACCOUNT_ID = 'accountId',
  ANALYTICS = 'analytics',
  LEFT_MENU_STATUS = 'left-menu-status',
  DEMO_MODE = 'demo-mode'
}
